const AuditLogsList = async () =>
    import('../../pages/audit/List').then((module) => ({
        Component: module.AuditLogsList,
    }));

const getAuditLogsRouter = (_user, _features) => [
    {
        path: '/audit',
        lazy: AuditLogsList,
    },
];

export { getAuditLogsRouter };
